var i = (t, o, r) => new Promise((n, c) => {
  var s = (e) => {
    try {
      p(r.next(e));
    } catch (a) {
      c(a);
    }
  }, d = (e) => {
    try {
      p(r.throw(e));
    } catch (a) {
      c(a);
    }
  }, p = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(s, d);
  p((r = r.apply(t, o)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function y(t) {
  return i(this, null, function* () {
    const {
      data: o
    } = yield l.post(
      "/designordercenter/productionOrder/specialApply/create",
      t
    );
    return o;
  });
}
export {
  y as postSpecialApplyCreate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/create/post.js
// module id = 327
// module chunks = 41